var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 8.00001H13.0135C12.7221 7.99939 12.4386 8.09421 12.2062 8.26999C11.9739 8.44576 11.8055 8.69281 11.7268 8.97334L10.1602 14.5467C10.1501 14.5813 10.129 14.6117 10.1002 14.6333C10.0713 14.655 10.0362 14.6667 10.0002 14.6667C9.9641 14.6667 9.92901 14.655 9.90016 14.6333C9.87131 14.6117 9.85026 14.5813 9.84016 14.5467L6.16016 1.45334C6.15007 1.41872 6.12901 1.38831 6.10016 1.36668C6.07131 1.34504 6.03622 1.33334 6.00016 1.33334C5.9641 1.33334 5.92901 1.34504 5.90016 1.36668C5.87131 1.38831 5.85026 1.41872 5.84016 1.45334L4.2735 7.02668C4.19514 7.30611 4.02775 7.55235 3.79674 7.72802C3.56573 7.90368 3.28371 7.99918 2.9935 8.00001H1.3335",
    stroke: "#717182",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulse);
export default __webpack_public_path__ + "static/media/pulse.256ece62d3f3a1c03aaf881491932351.svg";
export { ForwardRef as ReactComponent };